export default __webpack_public_path__ + "assets/images/777fd8bbaecf18bd143ab7ae61bf850b.png";